import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { IndividualAgeGroupReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class IndividualAgeGroupTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/airline/IndividualAgeGroupReferences'

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getIndividualAgeGroupTypeReferences(): Observable<IndividualAgeGroupReferenceModel[]> {
        return this.httpGet<IndividualAgeGroupReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}